import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const VALUES = [
  { t: "Integrity",   d: "We do what's right, always." },
  { t: "Empowerment", d: "We lift others up." },
  { t: "Excellence",  d: "We pursue growth and mastery." },
  { t: "Community",   d: "We grow stronger together." },
];

export default function About() {
  return (
    <div data-testid="about-page" className="bg-black text-white">
      {/* Hero — dark editorial */}
      <section className="sect-black pt-36 md:pt-44 pb-16 md:pb-20">
        <div className="bcu-container">
          <div className="flex items-center gap-4 mb-6">
            <img src="/assets/bcu_logo_official.png" alt="Bounce City University" className="h-16 md:h-20 w-auto" />
          </div>
          <p className="bcu-eyebrow bcu-eyebrow-gold">About Bounce City University</p>
          <h1 className="mt-6 font-display text-white text-5xl md:text-7xl lg:text-[86px] leading-[1.02] font-medium max-w-4xl">
            Built from real experience.
            <span className="block font-editorial italic font-medium text-[#D9A441] mt-3">Designed for real results.</span>
          </h1>
          <p className="mt-8 text-[#A9A9A9] text-[18px] leading-[1.75] max-w-[620px]">Bounce City University was created by an entrepreneur who has built and continues to operate a real inflatable rental company — and now teaches other entrepreneurs the same systems he uses every week.</p>
        </div>
      </section>

      {/* Ivory Founder editorial */}
      <section className="sect-ivory py-24 md:py-32 border-y border-[rgba(217,164,65,0.20)]">
        <div className="bcu-container grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="absolute -inset-6 rounded-sm bg-gradient-to-br from-[#D9A441]/15 to-transparent" />
              <img src="/assets/01_emmanuel_portrait.jpg" alt="Emmanuel Ternier — Founder, Bounce City" className="relative w-full max-h-[680px] object-cover object-top rounded-md drop-shadow-[0_20px_40px_rgba(20,17,12,0.25)]" />
            </div>
          </div>
          <div className="lg:col-span-7">
            <p className="bcu-eyebrow bcu-eyebrow-ink">Meet the Founder</p>
            <h2 className="mt-6 font-display text-[#14110C] text-5xl md:text-6xl leading-[1.04] font-semibold">Emmanuel Ternier</h2>
            <p className="mt-3 text-[15px] tracking-[0.10em] text-[#4A4335] font-medium">Founder &amp; CEO · Bounce City 321 · Bounce City University</p>

            <div className="mt-10 bcu-prose space-y-5 text-[#4A4335] text-[17px] md:text-[18px] leading-[1.75]">
              <p>For more than 13 years, Emmanuel has built, operated and expanded Bounce City 321 — a real inflatable rental company serving communities and organizations across Central Florida.</p>
              <p>His experience spans operations, logistics, staffing, marketing, customer service, safety and strategic growth. Bounce City has provided services for or worked with organizations including Tropicana, Walmart, Kennedy Space Center and Blue Origin.</p>
              <p>Bounce City University exists to give other entrepreneurs the same operating systems, procedures and mentorship that built the business — not classroom theory.</p>
            </div>
            <p className="mt-6 text-xs text-[#4A4335] italic max-w-lg">Organization names are referenced only to describe prior service relationships. No endorsement is implied.</p>

            <div className="mt-12 pt-10 border-t border-[rgba(20,17,12,0.14)] grid sm:grid-cols-2 gap-8">
              {VALUES.map((v) => (
                <div key={v.t}>
                  <div className="text-[11px] tracking-[0.28em] uppercase text-[#D9A441] font-semibold">Value</div>
                  <h3 className="mt-2 font-display text-[#14110C] text-2xl font-semibold">{v.t}</h3>
                  <p className="mt-2 text-[#4A4335] text-[15px] leading-relaxed">{v.d}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="sect-black py-24">
        <div className="bcu-container-narrow text-center">
          <p className="bcu-eyebrow bcu-eyebrow-gold justify-center" style={{ display: "inline-flex" }}>Our Mission</p>
          <p className="mt-8 pull-quote">To equip and empower entrepreneurs with the knowledge, systems and support to build profitable, freedom-driven businesses in the inflatable rental industry.</p>
          <p className="mt-6 font-editorial italic text-[#D9A441] text-2xl">We teach more than business. We build legacies.</p>
        </div>
      </section>

      {/* CTA */}
      <section className="sect-black-2 py-16 border-t border-[rgba(217,164,65,0.24)]">
        <div className="bcu-container flex items-center justify-between flex-wrap gap-6">
          <div className="font-display text-white text-2xl md:text-3xl max-w-2xl font-medium leading-tight">You don't have to figure it out alone. <span className="font-editorial italic text-[#D9A441]">Let us fast-track the work.</span></div>
          <Link to="/apply" data-testid="about-apply-btn" className="bcu-btn-primary">Apply for Bounce City University <ArrowRight className="h-4 w-4" /></Link>
        </div>
      </section>
    </div>
  );
}
